export default {
  // ==============================================
  // PRIMARY BRAND COLORS
  // ==============================================
  red: '#C43C42',
  red01: '#CA4E54',
  lightred: '#F3D8D9',
  lightredAlpha: 'rgba(243, 216, 217, 0.2)',
  green: '#C2CD23',

  // ==============================================
  // NEUTRAL COLORS
  // ==============================================
  black: '#000',
  black01: '#1F1F1F',
  white: '#FFF',

  // ==============================================
  // GRAY SCALE
  // ==============================================
  gray: '#808080',
  gray01: '#E5E5E5', // Light border gray
  gray02: '#333', // Dark text gray
  gray03: '#F1F1F1', // Light background gray
  lightgray: '#C7C7C7',

  // Additional gray variants found in codebase
  gray04: '#666', // Medium text gray
  gray05: '#828282', // Muted text gray
  gray06: '#999', // Placeholder gray
  gray07: '#ccc', // Border gray
  gray08: '#ddd', // Light border
  gray09: '#e0e0e0', // Very light border
  gray10: '#e9ecef', // Disabled border
  gray11: '#f5f5f5', // Light background
  gray12: '#f8f9fa', // Very light background
  gray13: '#e8e8e8', // Hover background
  gray14: '#6c757d', // Disabled text
  gray15: '#b3b3b3', // Inactive color

  // ==============================================
  // BLUE VARIATIONS
  // ==============================================
  info: '#007BFF',
  infoAlpha: 'rgba(0, 123, 255, 0.2)',

  // Additional blue variants found in codebase
  blue01: '#1976d2', // Primary blue
  blue02: '#1565c0', // Darker blue
  blue03: '#e3f2fd', // Light blue background
  blue04: '#dbeafe', // Hover blue background
  blue05: '#e8f4fd', // Expanded state background

  // ==============================================
  // STATUS COLORS
  // ==============================================
  warning: '#FFA500',
  warningAlpha: 'rgba(255, 165, 0, 0.2)',
  success: '#28A745',
  successAlpha: 'rgba(40, 167, 69, 0.2)',
  error: '#DC3545',
  errorAlpha: 'rgba(220, 53, 69, 0.2)',

  // Additional status variants
  error01: '#d32f2f', // Focus red
  error02: '#c82333', // Hover red
  error03: '#e74c3c', // Alternative red
  error04: '#fff5f5', // Light red background

  // ==============================================
  // INPUT & FORM COLORS
  // ==============================================
  inputFocusRed: '#d32f2f',
  inputFocusRedAlpha: 'rgba(211, 47, 47, 0.1)',
  inputBorderGray: '#ccc',
  inputHoverGray: '#999',
  inputTextGray: '#333',
  inputPlaceholderGray: '#999',
  inputHighlightBg: '#f5f5f5',
  inputMenuShadow: 'rgba(0, 0, 0, 0.1)',

  // ==============================================
  // SHADOW & OVERLAY COLORS
  // ==============================================
  shadowLight: 'rgba(0, 0, 0, 0.1)',
  shadowMedium: 'rgba(0, 0, 0, 0.15)',
  shadowDark: 'rgba(0, 0, 0, 0.2)',
  overlayDark: 'rgba(0, 0, 0, 0.5)',

  // ==============================================
  // SPECIAL EFFECT COLORS
  // ==============================================
  dashBorder: '#ccc', // Dashed border color
  highlightBorder: '#f0f0f0', // List item border

  // ==============================================
  // ADDITIONAL RGBA COLORS
  // ==============================================
  errorShadowAlpha: 'rgba(211, 47, 47, 0.3)',
  errorHoverShadowAlpha: 'rgba(220, 53, 69, 0.3)',

  // ==============================================
  // ADDITIONAL SPECIFIC COLORS
  // ==============================================
  blue06: '#1565c0', // Darker blue for hover states
  blue07: '#dbeafe', // Hover blue background
  blue08: '#e8f4fd', // Expanded state background
  gray16: '#f0f0f0', // List item border
  gray17: '#e8e8e8', // Hover background
  gray18: '#b3b3b3', // Inactive color
};
